// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yRF179YdZZ8HDHMnaIWa{flex-direction:column;gap:32px;padding-top:2px;padding-bottom:3px;display:flex}.ZXDPoEPSQcwJ4v6RowdM{flex-direction:column;gap:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `yRF179YdZZ8HDHMnaIWa`,
	"categories": `ZXDPoEPSQcwJ4v6RowdM`
};
export default ___CSS_LOADER_EXPORT___;
